import React, { useEffect, useState } from "react";
import styles from "./AdminImage.module.css";
import { Link, useNavigate, useParams } from "react-router-dom";
import { Button } from "react-bootstrap";
import ConfirmationPopup from "../ConfirmationPopup/ConfirmationPopup"; // Assuming you have a ConfirmationPopup component
import { AxiosInstance } from "../../../../../../axios";
import Loader from "../../../../Loader";
import dayjs from "dayjs";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { ImageUrlPrefix } from "../../../../../../labels";
import toast from "react-hot-toast";
import moment from "moment";

function ViewImageAdminInfo() {
  const navigate = useNavigate();
  const { id } = useParams();
  const userJSON = sessionStorage.getItem("userDetails");
  let userid = null;
  let user_type = null;
  if (userJSON) {
    const user = JSON.parse(userJSON);
    if (user && user.user_id) {
      userid = user.user_id;
      user_type = user.user_type;
    }
  } else {
    console.log("User Id not available in session storage");
  }

  const [isLoading, setIsLoading] = useState(false);
  const [folderImages, setFolderImages] = useState([]);

  const [selectedImageId, setSelectedImageId] = useState(null);
  const [selectedFolderId, setSelectedFolderId] = useState(null);
  const [showPopup, setShowPopup] = useState(false);
  const [currentImage, setCurrentImage] = useState(null);
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [showConfirmations, setShowConfirmations] = useState(false);

  const [existFolderData, setExistFolderData] = useState([]);

  useEffect(() => {
    // Only call API if `id` has a value to ensure data is fetched for the correct folder
    if (id) {
      handleMapNewFolderNames();
    }
  }, [id]);

  const handleMapNewFolderNames = async () => {
    setIsLoading(true);
    const folderPayloadImage = {
      img_type: 1, // 1 for image, 0 for video
      is_admin: user_type === 1 ? 1 : 0, // 1 - admin, 0 - except admin
      page: "", // page is empty, then all records are listed.
      page_size: "",
      folder_id: id,
    };
    // useEffect(() => {
    return AxiosInstance.post("/api/gallery/list", folderPayloadImage)
      .then((res) => {
        const imageFolderOptions = res.data?.data?.filter(
          (item) => item.folder_id == id
        );

        const sortedItems = imageFolderOptions.sort((a, b) => {
          if (a.display_option !== b.display_option) {
            // Sort by `display_option` (1 before 0)
            return b.display_option - a.display_option;
          }
          // If `display_option` is the same, sort by `created_dt` (newest first)
          return new Date(b.created_dt) - new Date(a.created_dt);
        });
        setExistFolderData(sortedItems);

        // setExistFolderData(imageFolderOptions);
      })
      .catch((error) => {
        return error;
      })
      .finally(() => {
        setIsLoading(false);
      });
  };
  // }, []);

  const handleBackFilter = () => {
    navigate(`/GalleryImages`);
  };

  const handleCheckboxChange = (id, foldrId) => {
    setSelectedImageId((prevId) => (prevId === id ? null : id));
    setSelectedFolderId((prevId) => (prevId === foldrId ? null : foldrId));
  };

  const handleDeleteImage = () => {
    if (selectedImageId !== null) {
      setShowConfirmation(true); // Show the confirmation popup
    }
  };
  const handleDeleteFolder = () => {
    if (existFolderData[0].folder_id !== null) {
      setShowConfirmations(true);
    }
  };
  const confirmDeleteImage = async () => {
    if (selectedImageId !== null) {
      try {
        let filteredObj = existFolderData.filter(
          (item) => item.id === selectedImageId
        )[0];
        let payload = {
          id: selectedImageId,
          folder_name: filteredObj.folder_name,
          folder_pk: selectedFolderId,
          display_option: 1,
          img_type: 1,
          title: "",
          is_deleted: 1,
          created_dt: dayjs().format("YYYY-MM-DD HH:mm:ss"),
          created_by: userid || "",
          files: [
            {
              path: filteredObj.gallery_path,
              originalname: filteredObj.original_gallery_path,
            },
          ],
        };
        await AxiosInstance.post(`/api/gallery/add`, payload)
          .then((res) => {
            if (res.status) {
              toast.success(res.data.message);
              navigate(`/ViewImages/${id}`);
            } else {
              toast.error(res.data.message);
            }
            setFolderImages((prevImages) =>
              prevImages.filter((image) => image.id !== selectedImageId)
            );
            setSelectedImageId(null);
            handleMapNewFolderNames();
            setShowConfirmation(false);
            setShowConfirmations(false);
          })
          .catch((error) => {
            return error;
          });
      } catch (error) {
        console.error("Error deleting the image:", error);
      }
    } else {
      try {
        let filteredObj = existFolderData.filter(
          (item) => item.id === selectedImageId
        )[0];
        let payload = {
          id: "",
          folder_name: filteredObj.folder_name,
          display_option: 1,
          img_type: 1,
          title: "",
          is_deleted: 1,
          created_dt: dayjs().format("YYYY-MM-DD HH:mm:ss"),
          created_by: userid || "",
          files: [
            {
              path: filteredObj.gallery_path,
              originalname: filteredObj.original_gallery_path,
            },
          ],
        };
        await AxiosInstance.post(`/api/gallery/add`, payload);

        // Filter out the deleted image from the folder images
        setFolderImages((prevImages) =>
          prevImages.filter((image) => image.id !== selectedImageId)
        );

        // Reset the selected image ID and close the confirmation popup
        setSelectedImageId(null);
        handleMapNewFolderNames();
        setShowConfirmation(false);
        setShowConfirmations(false);
      } catch (error) {
        console.error("Error deleting the image:", error);
      } // Warn if no image is selected
    }
  };

  const confirmDeleteFolder = async () => {
    if (existFolderData[0]?.folder_id !== null) {
      try {
        const updateCoures = {
          id: existFolderData[0].folder_id,
          folder_name: existFolderData[0].folder_name,
          type: existFolderData[0].img_type,
          is_deleted: 1,
          created_dt: moment().format("YYYY-MM-DD HH:mm:ss"),
          created_by: userid,
        };
        await AxiosInstance.post(`/api/gallery/add_folder`, updateCoures)
          .then((res) => {
            if (res.status) {
              toast.success(res.data.message);
              navigate("/GalleryImages");
            } else {
              toast.error(res.data.message);
            }
            setExistFolderData((prevItems) =>
              prevItems.filter(
                (item) => item.id !== existFolderData[0].folder_id
              )
            );
            setSelectedImageId(null);
            handleMapNewFolderNames();
            setShowConfirmation(false);
            setShowConfirmations(false);
          })
          .catch((error) => {
            return error;
          });
      } catch (error) {
        console.error("Error deleting item:", error);
      }
    } else {
      console.warn("No item selected for deletion.");
    }
  };

  const cancelDeleteImage = () => {
    setShowConfirmation(false); // Close the confirmation popup without deleting
  };
  const cancelDeleteFolder = () => {
    setShowConfirmations(false); // Close the confirmation popup without deleting
  };
  const handleEditImage = () => {
    if (selectedImageId) {
      const selectedFolder = existFolderData.find(
        (item) => item.id === selectedImageId
      );
      if (selectedFolder) {
        navigate(`/EditImage/${selectedImageId}`, {
          state: {
            FOLDER_PK: selectedFolder.folder_id || "",
            FOLDER_NAME: selectedFolder.folder_name || "",
            DISPLAY_OPTION: selectedFolder.display_option || "",
            ORIGINAL_GALLERY_PATH: selectedFolder.original_gallery_path || "",
            GALLERY_PATH: selectedFolder.gallery_path || "",
            DESCRIPTION: selectedFolder.description || "",
            CREATED_DATE: selectedFolder.created_date || "", // Example: Sending date
          },
        });
      }
    }
  };
  const handleEditFolder = () => {
    navigate(`/EditFolder/${id}/1`);
  };

  const handleImageClick = (src) => {
    setCurrentImage(src);
    setShowPopup(true);
  };

  const handleClosePopup = () => {
    setShowPopup(false);
    setCurrentImage(null);
  };

  return isLoading ? (
    <div
      className="loaderApi"
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "white",
        zIndex: 999,
      }}
    >
      <Loader />
    </div>
  ) : (
    <div className={`${styles.GalleryInfoSec} BathHeader global_container`}>
      <div className="row">
        <div className="col-md-4 col-12">
          <h2 className="TitleHeader">View Images</h2>
        </div>
        <div className="col-md-8 col-12 ListBtn">
          <ul className="List-Button">
            <li className="ListBtnItems">
              <Link
                onClick={handleBackFilter}
                to="javascript:void(0)"
                className="secondaryButton"
                variant="secondary"
              >
                Back to Images
              </Link>
            </li>
            {user_type === 1 && (
              <>
                <li className="ListBtnItems">
                  <Button
                    onClick={handleEditFolder}
                    className={`primaryButton text-center border-0 `}
                    variant="primary"
                  >
                    Edit Folder
                  </Button>
                </li>
                <li className="ListBtnItems">
                  <Link
                    className={`primaryButton text-center
                      }`}
                    onClick={handleDeleteFolder}
                  >
                    Delete Folder
                  </Link>
                </li>
                <li className="ListBtnItems">
                  <Button
                    onClick={handleEditImage}
                    className={`primaryButton text-center border-0 ${
                      selectedImageId ? "" : `${styles.editDisable}`
                    }`}
                    disabled={!selectedImageId}
                    variant="primary"
                  >
                    Edit Image
                  </Button>
                </li>
                <li className="ListBtnItems">
                  <Link
                    className={`primaryButton text-center ${
                      selectedImageId ? "" : "disabledbtn"
                    }`}
                    disabled={!selectedImageId}
                    onClick={handleDeleteImage}
                  >
                    Delete Image
                  </Link>
                </li>
              </>
            )}
          </ul>
        </div>
      </div>
      <div
        className={`${styles.gridContainer} row pt-2`}
        // style={{ maxHeight: "650px", overflowY: "auto" }}
      >
        {existFolderData.map((image) =>
          image.img_type === null ? (
            <div
              style={{
                display: "flex",
                fontSize: "16px",
                justifyContent: "center",
                alignItems: "center",
                height: "200px",
                textAlign: "center",
              }}
            >
              <p>No Images to Display</p>
            </div>
          ) : (
            <div key={image.id} className="col-md-3 col-12 mb-4">
              <div className={`${styles.image_card} card`}>
                <LazyLoadImage
                  src={`${ImageUrlPrefix}/${image.gallery_path}`}
                  alt={image.original_gallery_path || "Image"}
                  className={`${styles.image} card-img-top`}
                  // effect="blur"
                  onClick={() =>
                    handleImageClick(`${ImageUrlPrefix}/${image.gallery_path}`)
                  }
                  style={{
                    filter: image.display_option === 0 ? "blur(3px)" : "none", // Apply blur if display_option is 0
                  }}
                />
                <div className={styles.ImageDescription}>
                  <p>
                    {" "}
                    {image.s_no} {image.description ? "." : ""}{" "}
                    {image.description}
                  </p>
                </div>
                {user_type === 1 && (
                  <input
                    type="checkbox"
                    className={styles.checkbox}
                    checked={selectedImageId === image.id}
                    onChange={() =>
                      handleCheckboxChange(image.id, image.folder_id)
                    }
                    style={{
                      position: "absolute",
                      top: "10px",
                      right: "10px",
                      transform: "scale(1.5)",
                      cursor: "pointer",
                    }}
                  />
                )}
              </div>
            </div>
          )
        )}
      </div>

      {/* Popup for the image */}
      {showPopup && (
        <div className={styles.modal}>
          <span className={styles.close} onClick={handleClosePopup}>
            &times;
          </span>
          <img className={styles.modalImage} src={currentImage} alt="Zoomed" />
        </div>
      )}

      {/* Confirmation Popup */}
      {showConfirmation && (
        <ConfirmationPopup
          open={showConfirmation}
          title="Delete Image"
          message="Are you sure you want to delete this image?"
          onConfirm={confirmDeleteImage}
          onCancel={cancelDeleteImage}
        />
      )}
      {showConfirmations && (
        <ConfirmationPopup
          open={showConfirmations}
          title="Delete Folder"
          message="Are you sure you want to delete this folder?"
          onConfirm={confirmDeleteFolder}
          onCancel={cancelDeleteFolder}
        />
      )}
    </div>
  );
}

export default ViewImageAdminInfo;
